import { Platform } from "react-native";
import { Country, LOCALE, Locale } from "@lookiero/sty-psp-locale";
import { Segment } from "@lookiero/sty-psp-segment";
import { Tradename } from "@lookiero/sty-sp-tradename";

const DEV_ROOTS = ["style-profile", "next-best-action"] as const;

type DevRoot = (typeof DEV_ROOTS)[number];

interface DevSettings {
  readonly root: DevRoot;
  readonly tradename: Tradename;
  readonly locale: Locale;
  readonly country: Country;
  readonly segment: Segment;
  readonly customerId: string | undefined;
}

const isOneOf = <T extends string>(values: readonly T[], value: string | undefined): value is T =>
  (values as readonly string[]).includes(value ?? "");

const devSettingsFromSearch = (search: string): DevSettings | undefined => {
  const params = new URLSearchParams(search);
  const root = params.get("root") ?? undefined;

  if (!isOneOf(DEV_ROOTS, root)) {
    return undefined;
  }

  const tradename = params.get("tradename")?.toUpperCase();
  const locale = params.get("locale")?.replace("_", "-");
  const segment = params.get("segment")?.toUpperCase();
  const resolvedLocale = isOneOf(Object.values(Locale), locale) ? locale : Locale.es_ES;

  return {
    root,
    tradename: isOneOf(Object.values(Tradename), tradename) ? tradename : Tradename.LOOKIERO,
    locale: resolvedLocale,
    country: LOCALE[resolvedLocale][1],
    segment: isOneOf(Object.values(Segment), segment) ? segment : Segment.WOMEN,
    customerId: params.get("customerId") ?? undefined,
  };
};

const devSettings: DevSettings | undefined =
  Platform.OS === "web" && typeof window !== "undefined" ? devSettingsFromSearch(window.location.search) : undefined;

export { DEV_ROOTS, devSettings, devSettingsFromSearch };
export type { DevRoot, DevSettings };
